import React from 'react';
import ReactDOM from 'react-dom';
import './filePreviewModal.css';

export const FilePreviewModal = ({ file, onClose }) => {

    return ReactDOM.createPortal(
        <div className="modal-overlay preview-overlay" onClick={onClose}>
            <div
                className="modal-content preview-modal"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="modal-header">
                    <h3 className="modal-title">📄 {file.name}</h3>

                    <button
                        className="btn btn-icon btn-secondary"
                        onClick={onClose}
                        title="Cerrar"
                    >
                        ✕
                    </button>
                </div>

                <div className="modal-body preview-body">
                    {file.type === 'pdf' && (
                        <iframe
                            src={file.url}
                            className="pdf-preview"
                            title="Vista previa PDF"
                        />
                    )}

                    {file.type === 'xml' && (
                        <pre className="xml-preview">
                            <code>{file.content}</code>
                        </pre>
                    )}
                </div>

                <div className="modal-footer">

                    <button
                        className="btn btn-secondary"
                        onClick={onClose}
                    >
                        Cerrar
                    </button>

                    {/* {file.url && (
                        <a
                            href={file.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-primary"
                        >
                            Abrir en nueva pestaña
                        </a>
                    )} */}

                </div>
            </div>
        </div>,
        document.body
    );
};
